import { createSlice } from "@reduxjs/toolkit";

interface attributeSlice {
  attributesPnrr: [{}],
  attributesSdg: [{}],
  attributesAnvur: [{}],
}


// Define the initial state using that type
const initialState: attributeSlice = {
  attributesPnrr: null,
  attributesSdg: null,
  attributesAnvur: null,
};


export const attributeSlice = createSlice({
  name: "attributes",
  initialState: initialState,
  reducers: {
    addAttributesPnrr: (state, action) => {
      state.attributesPnrr = action.payload.attributesPnrr;
    },
    addAttributesSdg: (state, action) => {
      state.attributesSdg = action.payload.attributesSdg;
    },
    addAttributesAnvur: (state, action) => {
      state.attributesAnvur = action.payload.attributesAnvur;
    }
  },
});

export const { addAttributesPnrr, addAttributesSdg, addAttributesAnvur } = attributeSlice.actions;
export default attributeSlice.reducer;